<div
  class="ant-notification ant-notification-{{config.dwPlacement}}"
  [style.top]="(config.dwPlacement==='topLeft'||config.dwPlacement=='topRight')? config.dwTop:null"
  [style.bottom]="(config.dwPlacement==='bottomLeft'||config.dwPlacement=='bottomRight')? config.dwBottom:null"
  [style.right]="(config.dwPlacement==='bottomRight'||config.dwPlacement=='topRight')?'0px':null"
  [style.left]="(config.dwPlacement==='topLeft'||config.dwPlacement=='bottomLeft')?'0px':null">
  <dw-notification *ngFor="let message of messages; let i = index" [dwMessage]="message" [dwIndex]="i"></dw-notification>
</div>